@if (!outsideTheBox()) {
  <rt-box [class.background-light]="isCvEmpty" variant="no-padding vertical raised-higher">
    <div
      class="box-header header"
      padding-tb-small-x
      space-lr
      padding-top-small
      [attr.padding-bottom-small]="isCvEmpty || null"
    >
      <rt-heading variant="heading large light" class="color-darkest-x">
        {{ 'app.candidate.cv' | translate }}
      </rt-heading>
      <div class="actions">
        <ng-container *ngTemplateOutlet="cvActionsTpl()" />
      </div>
    </div>
    <ng-container [ngTemplateOutlet]="content" />
  </rt-box>
}

@if (outsideTheBox()) {
  <ng-container [ngTemplateOutlet]="content" />
}

<ng-template #content>
  <rt-file-handler [accept]="FileTypesCategory.CV" (nextFile)="changeCv($event)" />

  @if (error) {
    <div class="upload-error">
      {{ error }}
    </div>
  }

  @if (processingStatus() === 'anonymization_error' && state.cvState === CvState.Ready) {
    <rt-infobox
      [isDismissible]="false"
      type="warning"
      iconName="warning"
      margin-bottom-medium
      margin-top-small-xx
    >
      {{ 'app.candidate.anonymization.anonymization_failed' | translate }}
    </rt-infobox>
  }

  <div
    [attr.margin]="!outsideTheBox() || null"
    [attr.margin-top-small]="(!hasNewStyling() && outsideTheBox()) || null"
    [class.empty]="!url()"
    class="box-body body"
    layout-horizontal
    layout-justify-center
    layout-align-items-center
  >
    @switch (state.cvState) {
      @case (CvState.Empty) {
        <div layout-vertical layout-flex-1>
          @if (!hasNewStyling()) {
            <rt-divider variant="line" />
          }
          <rt-empty-state
            [title]="emptyState.title"
            [desc]="emptyState.desc"
            [icon]="emptyState.icon"
            [style.width]="'100%'"
            variant="small"
            [attr.padding-top-small]="!hasNewStyling() || null"
            [attr.margin-bottom]="hasNewStyling() || null"
          />
        </div>
      }

      @case (CvState.ProcessingFailed) {
        <rt-empty-state
          [icon]="'error-outline'"
          [title]="'app.candidate.cv_processing_failed_title' | translate"
          [hasContentMargin]="false"
          [style.width]="'100%'"
          variant="small"
          [attr.margin-bottom]="processingStatus() === 'error' || null"
        >
          <div class="description">
            {{ 'app.candidate.cv_processing_failed_description' | translate }}&nbsp;
          </div>
          <a (click)="openSupport()">{{ 'app.common.please_contact_support' | translate }}</a>
          @if (originalUrl) {
            <div class="button-wrapper">
              <a rt-button target="_self" [href]="originalUrl">
                <rt-icon name="file-download" />
                <span>{{ 'app.candidate.download_original_file' | translate }}</span>
              </a>
            </div>
          }
        </rt-empty-state>
      }

      @case (CvState.Ready) {
        <rt-pdf-viewer [assetUrl]="assetUrl!" (iframeLoad)="iframeLoad.emit($event)" />
      }

      @case (CvState.Processing) {
        <ng-container *ngTemplateOutlet="apiOperationTpl" />
      }

      @case (CvState.Loading) {
        <ng-container *ngTemplateOutlet="apiOperationTpl" />
      }
    }

    <ng-template #apiOperationTpl>
      <div
        layout-vertical
        layout-align-items-center
        layout-justify-center
        class="api-operation-tpl"
      >
        <rt-spinner />
        <p margin-top-small-x>{{ 'app.common.processing' | translate }}</p>
      </div>
    </ng-template>
  </div>
</ng-template>
